<div class="row" *ngIf='readOnly'>
  <div class="col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Single Use Device?</th>
                    <th class="col-sm-6">Maximum Number of Reuses</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Single Use Device?')">
                      <label controlName="singleUseDevice"> </label>
                    </td>
                    <td [ngClass]="isDefault('Maximum Number of Reuse')">
                      <label controlName="maxNumberOfReuse"> </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-3">Combination Product?</th>
                    <th class="col-sm-3">Kit?</th>
                    <th class="col-sm-3">Device or IVD Reagents?</th>
                    <th class="col-sm-3">Consumables or Equipment?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Combination Product?')">
                      <label controlName="combinationProduct"> </label>
                    </td>
                    <td [ngClass]="isDefault('Kit?')">
                      <label controlName="kit"> </label>
                    </td>
                    <td [ngClass]="isDefault('Device or IVD Reagents?')">
                      <label controlName="deviceOrIvdReagents"></label>
                    </td>
                    <td [ngClass]="isDefault('Consumables or Equipment?')">
                      <label controlName="consumablesOrEquipment"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-4 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Packaged or Labeled as Sterile?</th>
                    <th>Need Sterilization Before Use?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Packaged or Labeled as Sterile?')">
                      <label controlName="packagedOrLabeledAsSterile"></label>
                    </td>
                    <td [ngClass]="isDefault('Need Sterilization Before Use?')">
                      <label controlName="needSterilizationBeforeUse"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-3 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped" formArrayName="sterilizationMethodsForm">
                <tbody>
                  <tr>
                    <th>Sterilization Method(s)</th>
                  </tr>
                  <ng-container *ngIf="sterilizationMethodsForm?.controls?.length; else emptyTemplate1fields">
                    <tr formGroupName="{{i}}" *ngFor="let value of sterilizationMethodsForm.controls; let i = index">
                      <td [ngClass]="isDefault('Sterilization Method(s)')">
                        <label controlName="value"></label>
                      </td>

                    </tr>
                  </ng-container>
                </tbody>
              </table>

            </td>
            <td class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Sterilization Method Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Sterilization Method Description')" class="breakAll">
                      <label controlName="sterilizationMethodDescription"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">User Sterilization Required for Orthopedic Products?</th>
                    <th class="col-sm-6">Loaner Set/Orthopedic Set?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('User Sterilization Required for Orthopedic Products?')">
                      <label controlName="userSterilizationRequiredOrthopedicProducts"></label>
                    </td>
                    <td [ngClass]="isDefault('Loaner Set/Orthopedic Set?')">
                      <label controlName="loanerOrthopedicSet"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Packaged or Labeled as Sterile?</th>
                    <th class="col-sm-6">Need Sterilization Before Use?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Packaged or Labeled as Sterile?')">
                      <label controlName="packagedOrLabeledAsSterile"></label>
                    </td>
                    <td [ngClass]="isDefault('Need Sterilization Before Use?')">
                      <label controlName="needSterilizationBeforeUse"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Sterilization Method Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Sterilization Method Description')" class="breakAll">
                      <label controlName="sterilizationMethodDescription"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="clinicalSizeTypeForm" class="table table-inner table-condensed table-striped table-75">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Clinical Size Type</th>
                    <th class="col-sm-4">Value</th>
                    <th class="col-sm-4">Unit</th>
                  </tr>
                  <ng-container *ngIf="clinicalSizeTypeForm.controls.length; else emptyTemplate3fields">
                    <tr formGroupName="{{i}}" *ngFor="let sizeGroup of clinicalSizeTypeForm.controls; let i = index">
                      <td [ngClass]="isDefault('Clinical Size Type(s)')">
                        <label controlName="sizeType"></label>
                      </td>
                      <td [ngClass]="isDefault('Clinical Size Type(s)')">
                        <label controlName="sizeValue"></label>
                      </td>
                      <td [ngClass]="isDefault('Clinical Size Type(s)')">
                        <label controlName="sizeUnit"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Clinical Size Type and Measurement Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Clinical Size Type and Measurement Description')">
                      <label controlName="clinicalSizesDescription"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="storageHandlingForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Storage and Handling Conditions</th>
                    <th class="col-sm-2">Low Value</th>
                    <th class="col-sm-2">High Value</th>
                    <th class="col-sm-3">Unit</th>
                  </tr>
                  <ng-container *ngIf="storageHandlingForm?.controls?.length; else emptyTemplate4fields">
                    <tr formGroupName="{{i}}" *ngFor="let storage of storageHandlingForm.controls; let i = index"
                        [ngClass]="isDefault('Storage and Handling Conditions')">
                      <td class="breakAll">
                        <label controlName="storageHandlingCondition"></label>
                      </td>
                      <td>
                        <label controlName="valueLow"></label>
                      </td>
                      <td>
                        <label controlName="valueHigh"></label>
                      </td>
                      <td>
                        <label controlName="unit"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">

              <table class="table table-inner table-condensed table-striped table-50">
                <tbody>
                  <tr>
                    <th>Special Storage and Handling Condition</th>
                  </tr>
                  <tr>
                    <td class="breakAll" [ngClass]="isDefault('Special Storage and Handling Condition')">
                      <label controlName="specialStorageHandlingCondition"></label>
                    </td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">

              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Storage Condition</th>
                    <th class="col-sm-6">Distribution and Handling Condition</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Storage Condition')" class="breakAll"> <label controlName="storageCondition"></label></td>
                    <td [ngClass]="isDefault('Distribution and Handling Condition')" class="breakAll">
                      <label controlName="distributionAndHandlingCondition"></label>
                    </td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed" *ngIf="dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase()">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">

              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Registering Duplicate UDI-DI?</th>
                    <th class="col-sm-6">Reason for Registering Duplicate UDI-DI</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Registering Duplicate UDI-DI?')" class="breakAll">
                      <label controlName="registeringDuplicateUdidi"></label></td>
                    <td [ngClass]="isDefault('Reason for Registering Duplicate UDI-DI')" class="breakAll">
                      <label controlName="reasonForRegisteringDuplicateUdidi"></label>
                    </td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1fields>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
